import { Box, Typography } from '@mui/material';

import Flex, { FlexProps } from '@Components/Bases/Flex';

type OperatingYearRowProps = {
  startOperatingYear: number;
} & FlexProps;

const OperatingYearRow = (props: OperatingYearRowProps) => {
  const { startOperatingYear, ...restProps } = props;
  const yearColumn = startOperatingYear - 1;

  return (
    <Flex {...restProps}>
      <Box width={1} minWidth={235} maxWidth={350} />
      <Box
        ml={1}
        width={1}
        display={'grid'}
        gridTemplateColumns={'repeat(3, 1fr)'}
        gap={3}
      >
        {Array.from({ length: 3 })
          .map((_, index) => (
            <Typography key={index} textAlign={'center'} fontWeight={800}>
              {yearColumn - index}
            </Typography>
          ))
          .reverse()}
      </Box>
    </Flex>
  );
};

export default OperatingYearRow;
